import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { fetchTopKeywordsForDashboard } from "../../store/top_keywords/operations";
import {
  getOverview,
  getKeywords,
  getDefaultOrderBy,
  getDefaultOrderDir,
  isFetchingTopKeywordsForDashboard,
  hasTopKeywordsAndOverview
} from "../../store/top_keywords/selectors";
import { getSelectedWebsiteDomain, getSelectedWebsiteRegionalDatabase } from "../../store/tracked_websites/selectors";
import TopKeywordsBox from "../../components/Dashboard/TopKeywords/TopKeywordsBox";
import { DASHBOARD_LONG_POLLING_INTERVAL_IN_MS } from "../../settings/config";

class TopKeywordsBoxContainer extends Component {
  constructor(props) {
    super(props);

    this.refreshInterval = null;
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData();
    if (this.props.shouldLongPolling) {
      this.refreshInterval = setInterval(_ => {
        if (this.props.hasData || !this.props.shouldLongPolling) {
          clearInterval(this.refreshInterval);
        } else {
          this.fetchData();
        }
      }, DASHBOARD_LONG_POLLING_INTERVAL_IN_MS);
    }
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval);
  }

  fetchData() {
    this.props.fetchTopKeywordsForDashboard(
      this.props.domain,
      this.props.seoDb,
      this.props.orderBy,
      this.props.orderDir
    );
  }

  render() {
    return (
      <TopKeywordsBox
        isFetching={this.props.isFetchingData}
        overview={this.props.overview}
        keywords={this.props.keywords.slice(0, 5)}
        push={this.props.push}
        hasData={this.props.hasData}
      />
    );
  }
}

const mapStateToProps = state => {
  let sortBy = `${getSelectedWebsiteRegionalDatabase(state)}_${getDefaultOrderBy(state)}_${getDefaultOrderDir(state)}`;
  let domain = getSelectedWebsiteDomain(state);
  return {
    isFetchingData: isFetchingTopKeywordsForDashboard(state, domain),
    domain: domain,
    seoDb: getSelectedWebsiteRegionalDatabase(state),
    orderBy: getDefaultOrderBy(state),
    orderDir: getDefaultOrderDir(state),
    overview: getOverview(state),
    keywords: getKeywords(state, sortBy),
    hasData: hasTopKeywordsAndOverview(state, sortBy)
  };
};

export default connect(mapStateToProps, {
  fetchTopKeywordsForDashboard,
  push
})(TopKeywordsBoxContainer);
